import {
	MigrationManifest,
	PersistedState,
} from 'redux-persist';
import {
	ReducerInstance,
} from '@stores/lpdipro/reducers';

const migrations: MigrationManifest = {
	2: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// migration with app new data scheme
		return {
			...state,
			app: {
				instance: {
					desktop: {
						navIsOpen: false,
					},
					mobile: {
						navIsOpen: false,
					},
					navIsOpen: false,
				},
			},
		} as unknown as PersistedState;
	},

	3: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// migration with app new data scheme
		return {
			...state,

		} as unknown as PersistedState;
	},

	4: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// user authentication update
		return {
			...state,
			user: {
				instance: {
					authenticated: false,
					otherUsers: [] as string[],
					permissions: {},
				},
			},
		} as unknown as PersistedState;
	},

	5: (previousVersionState: PersistedState) => {
		const state = Object.fromEntries(Object.entries(previousVersionState as ReducerInstance).filter(([
			key,
		]) => key !== 'forms'));
		// login form inputs labels fix
		return {
			...state,
		} as unknown as PersistedState;
	},

	6: (previousVersionState: PersistedState) => {
		const state = Object.fromEntries(Object.entries(previousVersionState as ReducerInstance).filter(([
			key,
		]) => key !== 'forms'));
		// auth sms form input code label fix
		return {
			...state,
		} as unknown as PersistedState;
	},

	7: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// update app routes structure
		return {
			...state,
			app: {
				...state.app,
				routes: {
					from: null,
				},
			},
		} as unknown as PersistedState;
	},

	8: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// clear toast messages
		return {
			...state,
			toast_msgs: [] as string[],
		} as unknown as PersistedState;
	},

	9: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// update app instance structure
		return {
			...state,
			app: {
				instance: {
					dataLayer: [
						{},
					],
					desktop: {
						navIsOpen: false,
					},
					isLoading: true,
					localization: {
						actualLanguage: 'fr-FR',
						defaultLanguage: 'fr-FR',
					},
					mobile: {
						navIsOpen: false,
					},
					navIsOpen: false,
					routes: {
						from: null,
					},
					tablet: {
						navIsOpen: false,
					},
				},
			},
			forms: {
				instances: {},
			},
			toast_msgs: {
				instances: [] as string[],
			},
		} as unknown as PersistedState;
	},

	10: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// reset form instances
		return {
			...state,
			forms: {
				instances: [] as string[],
			},
		} as unknown as PersistedState;
	},

	11: (previousVersionState: PersistedState) => {
		const state = Object.fromEntries(Object.entries(previousVersionState as ReducerInstance).filter(([
			key,
		]) => key !== 'forms'));
		// login form inputs labels fix
		return {
			...state,
		} as unknown as PersistedState;
	},

	12: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// reset demands instances
		return {
			...state,
			demands: {
				instances: [] as string[],
			},
		} as unknown as PersistedState;
	},

	13: (previousVersionState: PersistedState) => {
		const state = Object.fromEntries(Object.entries(previousVersionState as ReducerInstance).filter(([
			key,
		]) => key !== 'app'));
		// add app instance config
		return {
			...state,
			app: {
				config: {},
				dataLayer: [
					{},
				],
				desktop: {
					navIsOpen: false,
				},
				isLoading: true,
				localization: {
					actualLanguage: 'fr-FR',
					defaultLanguage: 'fr-FR',
				},
				mobile: {
					navIsOpen: false,
				},
			},
		} as unknown as PersistedState;
	},

	14: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// add specification offers and specifications on initial state
		return {
			...state,
			demands: {
				instance: {
					collection: [],
					count: 0,
				},
			},
			specification_offers: {
				instance: {
					collection: [],
					count: 0,
				},
			},
			specifications: {
				instance: {
					collection: [],
					count: 0,
				},
			},
		} as unknown as PersistedState;
	},

	15: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// remove app instance config
		return {
			...state,
			app: {
				config: {},
				dataLayer: [
					{},
				],
				desktop: {
					navIsOpen: false,
				},
				isLoading: true,
				localization: {
					actualLanguage: 'fr-FR',
					defaultLanguage: 'fr-FR',
				},
				mobile: {
					navIsOpen: false,
				},
				navIsOpen: false,
				routes: {
					from: null,
				},
				tablet: {
					navIsOpen: false,
				},
			},
		} as unknown as PersistedState;
	},

	16: () => ({
		app: {
			config: {},
			dataLayer: [
				{},
			],
			desktop: {
				navIsOpen: false,
			},
			isLoading: true,
			localization: {
				actualLanguage: 'fr-FR',
				defaultLanguage: 'fr-FR',
			},
			mobile: {
				navIsOpen: false,
			},
			routes: {
				from: null as unknown as string,
			},
			tablet: {
				navIsOpen: false,
			},
		},
	}) as unknown as PersistedState,

	17: (previousVersionState: PersistedState) => {
		const state = previousVersionState as ReducerInstance;
		// reset app instance structure
		return {
			...state,
			app: {
				config: state?.app?.config ?? {},
				dataLayer: state?.app?.dataLayer ?? [
					{},
				],
				desktop: {
					navIsOpen: false,
				},
				isLoading: true,
				localization: {
					actualLanguage: 'fr-FR',
					defaultLanguage: 'fr-FR',
				},
				mobile: {
					navIsOpen: false,
				},
				routes: {
					from: (state?.app?.routes?.from ?? null) as unknown as string,
				},
				tablet: {
					navIsOpen: false,
				},
			},
		} as unknown as PersistedState;
	},

	18: () => undefined,
};

export default migrations;
